<div fxLayout="column" style="padding:15px;" fxLayoutAlign="center center center">

    <mat-card ngStyle.gt-lg="width:76%;" ngStyle.lg="width:86%;" ngStyle.lt-lg="width:100%;">
        <mat-card-title>
            <app-page-header [title]="pageTitle" action=''></app-page-header>
        </mat-card-title>
        <mat-card-content fxLayout="column" >

            <div fxLayout="row" fxFlex="grow" fxLayoutGap="10px" fxLayoutAlign="start center center">
                <mat-form-field>
                    <mat-label>Αναζήτηση</mat-label>
                    <input matInput (keypress)="searchStaff($event.target.value)" >
                </mat-form-field>


                <div fxFlex="grow">
                <button ngStyle.lt-md="width:100%;"
                        style="background: var(--primary); color:white; font-weight: normal; vertical-align: middle; border-radius: 50px;"
                        mat-flat-button [matMenuTriggerFor]="menu" #menuTrigger="matMenuTrigger">
                    Ενέργειες
                    &nbsp;
                    <mat-icon style="vertical-align: middle; color:white;">
                        {{menuTrigger.menuOpen ? 'expand_less' : 'expand_more'}}
                    </mat-icon>
                </button>

                <mat-menu #menu="matMenu">
                    <mat-list class="menuList">
                        <mat-list-item class="menuList" >
                            <button mat-menu-item  [disabled]="this.selection.selected.length === 0" (click)="assignFormToSelectedStaffMembers()">
                                <mat-icon class="icon">description</mat-icon>&nbsp;Δημοσίευση δήλωσης
                            </button>
                        </mat-list-item>

                        <mat-list-item class="menuList" >
                            <button mat-menu-item  [disabled]="this.selection.selected.length === 0" (click)="sendSMS()">
                                <mat-icon class="icon">description</mat-icon>&nbsp;Αποστολή μηνύματος SMS
                            </button>
                        </mat-list-item>
                    </mat-list>

                    <mat-list class="menuList">
                        <mat-list-item class="menuList" >
                            <button mat-menu-item (click)="exportToExcel()">
                                <mat-icon class="icon">description</mat-icon>&nbsp;Εξαγωγή σε xlsx
                            </button>
                        </mat-list-item>
                    </mat-list>

                </mat-menu>
                </div>
                <div fxLayoutAlign="flex-end" >
                    <label><u>Επιλεγμένοι  <b>{{selection.selected.length}}</b> εργαζόμενοι</u></label>
                </div>
            </div>


            <div fxLayout="column" fxFlex="grow">
                <mat-table  [dataSource]="staffMembers" style="width: 100%;">

                    <ng-container matColumnDef="select">
                        <mat-header-cell fxFlex="5"  *matHeaderCellDef fxLayoutAlign="start center center">
                            <mat-checkbox fxFlex="5" (change)="$event ? masterToggle() : null"
                                          [checked]="selection.hasValue() && isAllSelected()"
                                          [indeterminate]="selection.hasValue() && !isAllSelected()">
                            </mat-checkbox>
                        </mat-header-cell>
                        <mat-cell fxFlex="5"  *matCellDef="let row" fxLayoutAlign="start center center">
                            <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? selection.toggle(row) : null"
                                          [checked]="selection.isSelected(row)">
                            </mat-checkbox>
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="registrationNo">
                        <mat-header-cell class="tableCell" fxLayoutAlign="start center center" *matHeaderCellDef> A.M </mat-header-cell>
                        <mat-cell class="tableCell" fxLayoutAlign="start center center"  *matCellDef="let element"> {{element.registrationNo && element.registrationNo !== 'undefined' ? element.registrationNo : '-'}} </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="first_name">
                        <mat-header-cell class="tableCell" fxLayoutAlign="start center center" *matHeaderCellDef> Όνομα </mat-header-cell>
                        <mat-cell class="tableCell" fxLayoutAlign="start center center" *matCellDef="let element"> {{element.first_name}} </mat-cell>
                    </ng-container>

                    <!-- Name Column -->
                    <ng-container matColumnDef="last_name">
                        <mat-header-cell fxFlex="10" class="tableCell" fxLayoutAlign="start center center"  *matHeaderCellDef> Επώνυμο </mat-header-cell>
                        <mat-cell fxFlex="10" class="tableCell" fxLayoutAlign="start center center"  *matCellDef="let element"> {{element.last_name}} </mat-cell>
                    </ng-container>

                    <!-- Weight Column -->
                    <ng-container matColumnDef="email">
                        <mat-header-cell fxFlex="15" class="tableCell" fxLayoutAlign="start center center"  *matHeaderCellDef> Email </mat-header-cell>
                        <mat-cell fxFlex="15" class="tableCell" fxLayoutAlign="start center center" *matCellDef="let element"> {{element.email}} </mat-cell>
                    </ng-container>

                    <!-- Symbol Column -->
                    <ng-container matColumnDef="telephone">
                        <mat-header-cell class="tableCell" fxLayoutAlign="start center center" *matHeaderCellDef> Τηλέφωνο </mat-header-cell>
                        <mat-cell class="tableCell" fxLayoutAlign="start center center" *matCellDef="let element"> {{element.telephone}} </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="position">
                        <mat-header-cell class="tableCell" fxLayoutAlign="start center center" *matHeaderCellDef> Θέση </mat-header-cell>
                        <mat-cell class="tableCell" fxLayoutAlign="start center center" *matCellDef="let element"> {{element.position && element.position !== 'undefined' ? element.position : '-'}} </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="specialty">
                        <mat-header-cell class="tableCell" fxLayoutAlign="start center center" *matHeaderCellDef> Ειδικότητα </mat-header-cell>
                        <mat-cell class="tableCell" fxLayoutAlign="start center center" *matCellDef="let element"> {{element.specialty && element.specialty !== 'undefined' ? element.specialty : '-'}} </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="school_unit_description">
                        <mat-header-cell class="tableCell" fxLayoutAlign="start center center" *matHeaderCellDef> Σχολική μονάδα </mat-header-cell>
                        <mat-cell class="tableCell" fxLayoutAlign="start center center" *matCellDef="let element"> {{element.school_unit_description && element.school_unit_description !== 'undefined' ? element.school_unit_description : '-'}} </mat-cell>
                    </ng-container>

<!--                    <ng-container matColumnDef="school_unit_description">-->
<!--                        <mat-header-cell fxFlex="15" class="tableCell" fxLayoutAlign="start center center" *matHeaderCellDef> Σχολική μονάδα </mat-header-cell>-->
<!--                        <mat-cell fxFlex="15" class="tableCell" fxLayoutAlign="start center center" *matCellDef="let element">-->
<!--                            <mat-form-field appearance="standard">-->
<!--                            <mat-select (closed)="changeSchoolUnit(element)" multiple [compareWith]="equals" [(ngModel)]="element.units" >-->
<!--                                <mat-option *ngFor="let unit of units" [value]=unit>{{unit.description}}</mat-option>-->
<!--                            </mat-select>-->
<!--                            </mat-form-field>-->
<!--                             </mat-cell>-->
<!--                    </ng-container>-->


                    <ng-container matColumnDef="school_level_description">
                        <mat-header-cell fxFlex="15" class="tableCell" fxLayoutAlign="start center center" *matHeaderCellDef> Σχολείο </mat-header-cell>
                        <mat-cell fxFlex="15" class="tableCell" fxLayoutAlign="start center center" *matCellDef="let element">
                            <mat-form-field appearance="standard">
                            <mat-select (closed)="changeSchoolLevel(element)" multiple [compareWith]="equals" [(ngModel)]="element.levels" >
                                <mat-option *ngFor="let level of levels" [value]=level [disabled]="checkInitialMemberLevel(element, level)"> {{displayLevelName(level)}}</mat-option>
                            </mat-select>
                            </mat-form-field>
                        </mat-cell>
                    </ng-container>

                  <ng-container matColumnDef="roles">
                    <mat-header-cell fxFlex="15" class="tableCell" fxLayoutAlign="start center center" *matHeaderCellDef> Ρόλοι </mat-header-cell>
                    <mat-cell fxFlex="15" class="tableCell" fxLayoutAlign="start center center" *matCellDef="let element">
                        <mat-form-field appearance="standard">
                    <mat-select (closed)="changeRole(element)" multiple [compareWith]="equals" [(ngModel)]="element.roles" >
                      <mat-option *ngFor="let role of roles" [value]=role>{{role.role_name}}</mat-option>
                    </mat-select>
                        </mat-form-field>

                    </mat-cell>
                  </ng-container>

                    <mat-header-row  *matHeaderRowDef="displayColumns"></mat-header-row>
                    <mat-row  *matRowDef="let row; columns: displayColumns;"></mat-row>
                </mat-table>

                <div *ngIf="isLoading">
                    <app-skeleton-loading></app-skeleton-loading>
                </div>

                <div *ngIf="staffMembers.data.length === 0 && !isLoading" fxLayoutAlign="center center center"
                     style="margin-top:50px; margin-bottom: 50px;">
                    Δεν υπάρχουν χρήστες με αυτά τα κριτήρια
                </div>
            </div>
            <div fxLayout="row" fxLayoutAlign="end center center" style="margin-top:5px;">
                <mat-paginator [length]="staffMembers.data.length" [pageSize]="50" [pageSizeOptions]="[10,20, 50, 100, 200, 400]">
                </mat-paginator>
            </div>
        </mat-card-content>
    </mat-card>
</div>
